export default __webpack_public_path__ + "static/media/nav-message-icon.1a028ebf.svg";